import { LayerId } from "@lidojs/design-core";

export const makeMapLayers = (array: LayerId[]): {[key: LayerId]: number} => {
  return array.reduce((acc, curr, index) => {
    acc[curr] = index + 1;
    return acc;
  }, {});
}
